<template>
  <div class="w-full">
    <div class="w-full flex justify-end">
      <vs-button
        icon-pack="feather"
        type="border"
        icon="icon-filter"
        class="mr-3"
        @click="isFilter = !isFilter"
        >Filter</vs-button
      >
      <div>
        <vs-input
          icon-pack="feather"
          icon="icon-search"
          placeholder="Cari"
          v-model="search"
        />
      </div>
    </div>

    <vx-card title="Filter Berdasarkan" class="my-5" v-if="isFilter">
      <div class="w-full flex flex-col md:flex-row">
        <div class="w-full md:w-1/3 px-3 mb-4">
          <div class="mb-2">Status Surat</div>
          <vs-select :options="listStatus" v-model="filterStatus"></vs-select>
        </div>
        <div class="w-full md:w-1/3 px-3">
          <div class="mb-2">Kategori Surat</div>
          <vs-select :options="listKategoriSurat" v-model="filterKategoriSurat"></vs-select>
        </div>
        <div class="w-full md:w-1/3 px-3">
          <div class="mb-2">Tipe Surat</div>
          <vs-select :options="listTipeSuratMasuk" v-model="filterTipeSuratMasuk"></vs-select>
        </div>
      </div>
      <br><hr><br>
      <div class="w-full flex flex-col md:flex-row">
        <div class="w-full md:w-1/3 px-3 mb-4">
          <div class="mb-2">Dari Tanggal</div>
          <flat-pickr
            :config="configdateTimePicker"
            v-model="filterStartDate"
            class="w-full"
            placeholder="Pilih Tanggal Mulai"
          />
        </div>
        <div class="w-full md:w-1/3 px-3">
          <div class="mb-2">Sampai Tanggal</div>
          <flat-pickr
            :config="configdateTimePicker"
            v-model="filterEndDate"
            class="w-full"
            placeholder="Pilih Tanggal Selesai"
          />
        </div>
        <div class="w-full md:w-1/3 px-3">
          <div class="mb-2">&nbsp;&nbsp;</div>
          <vs-button
            icon-pack="feather"
            type="border"
            color="grey"
            text-color="black"
            icon="icon-refresh-ccw"
            class="mr-3"
            @click="resetTanggal()"
            >Reset Tanggal</vs-button
          >
        </div>
      </div>
    </vx-card>

    <global-wrapper
      :loading="$apollo.queries.suratList.loading"
      :loadingType="'OneLine'"
      :loadingList="5"
      :empty="suratListModifier.length <= 0"
      :error="false"
    >
      <global-table
        @reloadData="handleOnReloadData($event)"
        :currentPage="pagination.currentPage"
        :totalPage="pagination.totalPage"
      >
        <template #thead>
          <global-th width="20px">No.</global-th>
          <global-th>Nomor</global-th>
          <global-th>Asal Surat</global-th>
          <global-th>Perihal</global-th>
          <global-th>Tanggal</global-th>
          <global-th>Status</global-th>
          <global-th>Action</global-th>
        </template>
        <template #tbody>
          <global-tr
            v-for="(item, index) in suratListModifier"
            :key="index"
          >
            <global-td>{{ item.number }}</global-td>
            <global-td>{{ item.nomor_surat.nomor }}</global-td>
            <global-td>{{ item.surat_masuk.pengirim }}</global-td>
            <global-td>{{ item.perihal }}</global-td>
            <global-td
              ><div class="whitespace-no-wrap">
                {{ item.tanggal | indonesian_date }}
              </div></global-td
            >
            <global-td><StatusChip :status="item.status"/></global-td>
            <global-td
              ><vs-button
                type="border"
                size="small"
                @click="clickedDetail(item.uuid)"
                >Detail</vs-button
              ></global-td
            >
          </global-tr>
        </template>
      </global-table>
    </global-wrapper>
  </div>
</template>

<script>
import _ from "lodash";
import VsSelect from "vue-select";
import StatusChip from "@/components/global/surat/StatusChip.vue";
import { GET_ALL_FILTER } from "@/query/surat";
import { GET_ALL as ALL_BIDANG } from "@/query/bidang";
import { GET_ALL as ALL_KATEGORI } from "@/query/kategori-surat";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  STATUS_ACCEPT,
  STATUS_CONCEPT,
  STATUS_ARCHIVE,
  STATUS_DRAFT,
  STATUS_TRASH
} from "@/const/surat";

export default {
  components: {
    StatusChip,
    VsSelect,
    flatPickr
  },
  data() {
    return {
      skipQuerySurat: true,
      isFilter: false,
      filterKategoriSurat: {value: null, label: 'Semua Kategori'},
      listKategoriSurat: [],
      filterTipeSuratMasuk: {value: null, label: 'Semua Tipe'},
      listTipeSuratMasuk: [
        {
          value: null,
          label: "Semua Tipe"
        },
        {
          value: "surat_masuk",
          label: "Surat Masuk"
        },
        {
          value: "tembusan",
          label: "Tembusan"
        }
      ],
      filterStatus: {value: null, label: 'Semua Status'},
      listStatus: [
        {
          value: null,
          label: "Semua Status"
        },
        {
          value: STATUS_CONCEPT,
          label: "Konsep"
        },
        {
          value: STATUS_DRAFT,
          label: "Draft"
        },
        {
          value: STATUS_ACCEPT,
          label: "Acc Proses"
        },
        {
          value: STATUS_ARCHIVE,
          label: "Arsip"
        },
        {
          value: STATUS_TRASH,
          label: "Sampah"
        }
      ],
      pagination: {
        perPage: 10,
        totalPage: 0,
        currentPage: 1
      },
      search: "",
      configdateTimePicker: {
        enableTime: false,
        dateFormat: "Y-m-d",
        time_24hr: true
      },
      filterStartDate: null,
      filterEndDate: null,
    };
  },
  apollo: {
    listBidang: {
      query: ALL_BIDANG,
      variables: {
        perPage: 1000
      },
      update: data => {
        const list = data.bidang.data.map(({ id, nama }) => ({
          value: id,
          label: nama
        }));
        
        list.unshift({value: null, label: 'Semua Bidang'});
        return list;
      },
      fetchPolicy: "cache-and-network"
    },
    listKategoriSurat: {
      query: ALL_KATEGORI,
      variables: {
        perPage: 1000
      },
      update: data => {
        const list = data.kategoriSurat.data.map(({ id, nama }) => ({
          value: id,
          label: nama
        }));
        
        list.unshift({value: null, label: 'Semua Kategori'});
        return list;
      },
      fetchPolicy: "cache-and-network"
    },
    suratList: {
      query() {
        return GET_ALL_FILTER;
      },
      update(data) {
        return this.suratListData(data);
      },
      error() {
        this.error = true;
      },
      skip() {
        return this.skipQuerySurat;
      },
      fetchPolicy: "network"
    }
  },
  computed: {
    variables() {
      return {
        perPage: this.pagination.perPage,
        page: this.pagination.currentPage,
        orderBy: [
          {
            field: "TANGGAL",
            order: "DESC"
          }
        ],
        where: {
          AND: [
            {
              column: "PERIHAL",
              operator: "LIKE",
              value: `%${this.search}%`
            }
          ]
        },
        filter: {
          tipe: 'surat_masuk',
          status: this.filterStatus.value || null,
          kategoriSuratId: this.filterKategoriSurat.value || null,
          tipeSuratMasuk: this.filterTipeSuratMasuk.value || null,
          startDate: this.filterStartDate,
          endDate: this.filterEndDate
        }
      };
    },
    suratListModifier() {
      if (typeof this.suratList == "undefined") return [];

      const lastNumber = Math.ceil(
        this.pagination.perPage * (this.pagination.currentPage - 1)
      );
      return this.suratList.map((data, index) => {
        return { ...data, number: lastNumber + index + 1 };
      });
    },
    filterModifier(){
      const {filterTipeSuratMasuk, filterKategoriSurat, filterStatus, search, filterStartDate, filterEndDate} = this
      return {filterTipeSuratMasuk, filterKategoriSurat, filterStatus, search, filterStartDate, filterEndDate};
    }
  },
  watch: {
    filterModifier: {
      handler(){
        this.refetchQuerySurat();
      },
      deep: true
    },
    filterStatus:{
      handler(){
        if(this.filterStatus == null){
          this.filterStatus = {value: null, label: 'Semua Status'};
        }
      },
      deep: true
    },
    filterKategoriSurat:{
      handler(){
        if(this.filterKategoriSurat == null){
          this.filterKategoriSurat = {value: null, label: 'Semua Kategori'};
        }
      },
      deep: true
    },
    filterTipeSuratMasuk:{
      handler(){
        if(this.filterTipeSuratMasuk == null){
          this.filterTipeSuratMasuk = {value: null, label: 'Semua Tipe'};
        }
      },
      deep: true
    }
  },
  mounted() {
    this.fetchQuerySurat();
  },
  methods: {
    suratListData(data) {
      this.pagination.totalPage = data.surat.paginatorInfo.lastPage;
      return data.surat.data;
    },
    handleOnReloadData(currentPage) {
      this.pagination.currentPage = currentPage;
      this.fetchQuerySurat();
    },
    refetchQuerySurat: _.debounce(function() {
      this.fetchQuerySurat();
    }, 300),
    fetchQuerySurat() {
      this.$nextTick().then(() => {
        this.error = false;
        this.skipQuerySurat = false;
        this.paginationPage = 1;
        this.$apollo.queries.suratList.setVariables({ ...this.variables });
        this.$apollo.queries.suratList.refetch();
      });
    },
    clickedDetail(uuid) {
      this.$router.push({
        name: "surat-masuk-detail",
        params: {
          uuid: uuid
        }
      });
    },
    resetTanggal(){
      this.filterStartDate = null;
      this.filterEndDate = null;
    }
  }
};
</script>
